var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "url(#paint0_linear_539_9254)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8422 9.00121C44.119 9.04625 46.1785 10.3443 47.1753 12.3626L68.3879 55.3126C69.3308 57.2219 69.176 59.4808 67.981 61.2477C63.2423 68.2543 54.9811 71.7449 47.062 70.8667C38.8259 69.9534 31.4129 64.3984 28.4505 54.5431C28.2328 53.8187 28.1607 53.0859 28.2176 52.3752L22.412 63.0222C20.8256 65.9315 17.1471 67.0222 14.1958 65.4585C11.2444 63.8948 10.1379 60.2688 11.7242 57.3595L36.3766 12.149C37.4548 10.1717 39.5654 8.95617 41.8422 9.00121ZM30.5329 48.1291C31.1156 47.6804 31.792 47.3299 32.5439 47.1102C35.7565 46.1719 39.1325 47.9785 40.0844 51.1452C41.7085 56.5485 45.1884 58.6228 48.4185 58.981C50.9522 59.262 53.6038 58.5282 55.6925 56.9323L41.4534 28.1018L30.5329 48.1291Z",
    fill: "#F4FCE1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_539_9254",
    x1: -14.4228,
    y1: 79.2195,
    x2: 49.5913,
    y2: -6.39269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A844D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDD372"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo-square.1bc73a6f84cd79cc7c1012ae233a7489.svg";
export { ForwardRef as ReactComponent };